const SET_FILTERS = 'leads/filterStatus/SET_FILTERS';

const ADD_FILTER = 'leads/filterStatus/ADD_FILTER';
const REMOVE_FILTER = 'leads/filterStatus/REMOVE_FILTER';

const FETCH_COUNTER_LEAD = 'leads/filterStatus/FETCH_COUNTER_LEAD';
const FETCH_COUNTER_LEAD_SUCCEEDED = 'leads/filterStatus/FETCH_COUNTER_LEAD_SUCCEEDED';
const FETCH_COUNTER_LEAD_FAILED = 'leads/filterStatus/FETCH_COUNTER_LEAD_FAILED';

export {
  SET_FILTERS,
  ADD_FILTER,
  REMOVE_FILTER,
  FETCH_COUNTER_LEAD,
  FETCH_COUNTER_LEAD_SUCCEEDED,
  FETCH_COUNTER_LEAD_FAILED
};
